import { Typography } from '@material-ui/core'

import api from 'common/api'
import { useScid } from 'store/user/hooks'

import { NonDismissibleDialog } from '@scoir/modals'

const { Body, Footer } = NonDismissibleDialog

export const DELETE_MODAL_TEXT = {
  title: 'Confirm Delete',
  body: 'Are you sure you want to delete this extension?',
}

type deleteProps = {
  open: boolean
  onClose: (_?: object, reason?: string) => void
  extensionId?: string
  getExtensions: () => void
}

const DeleteConfirm = ({ open, onClose, extensionId, getExtensions }: deleteProps) => {
  const scid = useScid()

  return (
    <NonDismissibleDialog
      open={open}
      onClose={onClose}
      aria-label={DELETE_MODAL_TEXT.title}
      headerText={DELETE_MODAL_TEXT.title}
      scroll="paper"
    >
      <Body>
        <Typography>{DELETE_MODAL_TEXT.body}</Typography>
      </Body>
      <Footer>
        <Footer.CloseButton>Cancel</Footer.CloseButton>
        <Footer.PrimaryActionButton
          onClick={() => {
            api.delete(`/api/colleges/${scid}/applications/extensions/${extensionId}`).then(() => {
              getExtensions()
              onClose()
            })
          }}
        >
          Confirm
        </Footer.PrimaryActionButton>
      </Footer>
    </NonDismissibleDialog>
  )
}

export default DeleteConfirm
